@if (model) {
  <cms-blog-content-post-listing
  [model]="model"></cms-blog-content-post-listing>
}
